import { ListBaseModel } from '../commonModels';
import { ResponseBase } from '../commonModels';

export class ServiceCompaniesListModel extends ListBaseModel {
 Items: ServiceCompanyModel[];

  constructor() {
    super();
    this.Items = [];
    this.TotalItems = 0;
    this.CurrentPage = 0;
    this.PageCount = 0;
    this.Success = true;
  }
}

export class ServiceCompanyObjectModel extends ResponseBase {
  Item: ServiceCompanyModel;
}

export class ServiceCompanyBaseModel {
  public ServiceCompanyId: number; // ID firmy
  public Name: string; // Nazwa
  public Nip: string; // NIP
  public Contact: string; // Telefon ogólny
  public Address: string; // Adres
  public OwnerName: string; // Nazwa właściciela
  public OwnerTelephone: string; // Telefon właściciela
  public OwnerMail: string; // Email właściciela
  public IsActive: boolean; // badge -> Nieaktywny
  public ServiceCompanyTypeId: number; // Partnerski / własny
  public IsTyrespanel: boolean; // Tyrespanel
  public GaragesCount: number;
  public ActiveGaragesCount: number;
  public InactiveGaragesCount: number;
  public AddedByUser: string;
  public AddedByUserId: number;
  public AddDate: Date;
  public OcPolicy: Date;
  public AllEdiAddressesAvailable: boolean;
  public DeactivationDate: Date;
  public DeactivatedByUserId: number;
  public DeactivatedByUser: string;
  public AgreementFileName: string;
  public OtherFileName: string;
  public AgreementDocumentId: number;
  public OtherDocumentId: number;

  constructor() {
    this.Name = null;
    this.Nip = null;
    this.Contact = null;
    this.Address = null;
    this.OwnerName = null;
    this.OwnerTelephone = null;
    this.OwnerMail = null;
    this.IsActive = true;
    this.ServiceCompanyTypeId = null;
    this.IsTyrespanel = false;
    this.AllEdiAddressesAvailable = false;
    this.AgreementFileName = null;
    this.OtherFileName = null;
  }
}
export class ServiceCompanyFilesModel {
  public AgreementFile: any;
  public OtherFile: any;
}


export class ServiceCompanyModel extends ServiceCompanyBaseModel {
  public AgreementFile: any;
  public OtherFile: any;

  constructor() {
    super();
  }

}

export class ServiceCompaniesDictionary extends ListBaseModel {
  Items: ServiceCompaniesPreviewModel[];

}
export class ServiceCompaniesPreviewModel {
  public ServiceCompanyId: number; // ID firmy
  public Name; // Nazwa
  public IsActive; // badge -> Nieaktywny

}

export class ServiceCompaniesTypesListModel extends ListBaseModel {
  Items: ServiceCompaniesTypesModel[];

}

export class ServiceCompaniesTypesModel {
  public ServiceCompanyTypeId: number;
  public Name: string;
}
